import React from 'react';
import { history } from '../store'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { updateClient } from '../actions/customers'
import LoginLangSelector from '../components/LoginLangSelector'

const STYLES = `
.lv-wrap{display:flex;min-height:100vh;background:url(/images/login_bg.png) center/cover no-repeat;position:relative}
.lv-wrap::before{content:'';position:absolute;inset:0;pointer-events:none}
.lv-hero{flex:1;position:sticky;top:0;height:100vh;display:flex;align-items:center;justify-content:center;padding:40px;z-index:1}
.lv-hero img{max-width:480px;width:100%;opacity:.9}
.lv-panel{width:480px;min-height:100vh;background:rgba(0,18,40,.50);backdrop-filter:blur(14px);border-left:1px solid rgba(255,255,255,.12);display:flex;flex-direction:column;align-items:center;justify-content:center;padding:48px 40px;overflow-y:auto;position:relative;z-index:1}
.lv-logo{height:42px;margin-bottom:8px}
.lv-title{color:#fff;font-size:22px;font-weight:700;letter-spacing:4px;margin-bottom:24px}
.lv-subtitle{color:rgba(255,255,255,.85);font-size:13px;text-align:center;margin-bottom:24px;line-height:1.6}
.lv-form{width:100%}
.lv-field{margin-bottom:16px}
.lv-label{display:block;color:rgba(255,255,255,.7);font-size:13px;margin-bottom:6px}
.lv-input-wrap{position:relative;display:flex;align-items:center}
.lv-input{width:100%;padding:11px 14px;border-radius:10px;border:1.5px solid rgba(255,255,255,.15);background:rgba(255,255,255,.08);color:#fff;font-size:14px;outline:none;box-sizing:border-box;transition:border-color .2s}
.lv-input::placeholder{color:rgba(255,255,255,.35)}
.lv-input:focus{border-color:rgba(255,255,255,.5)}
.lv-eye{position:absolute;right:12px;background:none;border:none;color:rgba(255,255,255,.45);cursor:pointer;font-size:16px;padding:4px;line-height:1}
.lv-btn{width:100%;padding:13px;border-radius:40px;border:none;background:#fff;color:#001830;font-weight:700;font-size:15px;cursor:pointer;transition:opacity .2s;margin-top:8px}
.lv-btn:disabled{opacity:.5;cursor:not-allowed}
.lv-err{background:rgba(248,113,113,.15);border:1px solid rgba(248,113,113,.4);color:#fca5a5;padding:10px 14px;border-radius:8px;font-size:13px;margin-top:12px}
.lv-ok{background:rgba(74,222,128,.12);border:1px solid rgba(74,222,128,.35);color:rgba(255,255,255,.7);padding:14px 16px;border-radius:8px;font-size:13px;line-height:1.6;text-align:center;margin-bottom:16px}
.lv-hint{color:rgba(255,255,255,.4);font-size:11px;margin-top:5px;line-height:1.5}
@media(max-width:820px){.lv-panel{width:100%;border-left:none;padding:32px 24px}}
`

function validatePassword(password) {
  if (password.length < 8) return 'Mínimo 8 caracteres.'
  if (!/[A-Z]/.test(password)) return 'Debe incluir al menos una mayúscula.'
  if (!/[0-9]/.test(password)) return 'Debe incluir al menos un número.'
  if (!/[^A-Za-z0-9]/.test(password)) return 'Debe incluir al menos un símbolo.'
  return null
}

class PasswordAssignClientView extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      password: '',
      confirmPassword: '',
      showPassword: false,
      showConfirm: false,
      error: '',
      loading: false,
      success: false
    }
  }

  componentDidMount() {
    if (!document.getElementById('lv-styles-assign')) {
      const s = document.createElement('style'); s.id = 'lv-styles-assign'; s.textContent = STYLES; document.head.appendChild(s)
    }
  }

  async handleSubmit(e) {
    e.preventDefault()
    const { password, confirmPassword } = this.state
    const validationError = validatePassword(password)
    if (validationError) { this.setState({ error: validationError }); return }
    if (password !== confirmPassword) { this.setState({ error: 'Las contraseñas no coinciden.' }); return }
    const searchParams = new URLSearchParams(this.props.location.search)
    const customerID = searchParams.get('un')
    if (!customerID) { this.setState({ error: 'Enlace de cambio de contraseña inválido.' }); return }
    this.setState({ loading: true, error: '' })
    const result = await this.props.updateClient(customerID, { password, confirmPassword })
    if (result && result.error) {
      this.setState({ error: result.error.message || 'Error al guardar la contraseña.', loading: false })
    } else {
      this.setState({ success: true, loading: false })
    }
  }

  render() {
    const { password, confirmPassword, showPassword, showConfirm, error, loading, success } = this.state
    return (
      <div className="lv-wrap">
        <div className="lv-hero">
          <img src="/images/lockers_render.png" alt="VACWAYlockers" />
        </div>
        <div className="lv-panel">
          <LoginLangSelector />
          <img className="lv-logo" src="/images/logo.svg" alt="VACWAYlockers" />
          <div className="lv-title">SMART LOCKERS</div>
          {success ? (
            <>
              <div className="lv-ok">
                Tu contraseña se ha cambiado correctamente.<br />
                Ya puedes iniciar sesión.
              </div>
              <button className="lv-btn" onClick={() => history.push('/')}>Iniciar sesión</button>
            </>
          ) : (
            <>
              <div className="lv-subtitle">Elige una nueva contraseña segura para tu cuenta.</div>
              <form className="lv-form" onSubmit={e => this.handleSubmit(e)}>
                <div className="lv-field">
                  <label className="lv-label">Nueva contraseña</label>
                  <div className="lv-input-wrap">
                    <input className="lv-input" type={showPassword ? 'text' : 'password'} value={password}
                      autoComplete="new-password" placeholder="••••••••"
                      onChange={e => this.setState({ password: e.target.value })}
                      style={{ paddingRight: 40 }} />
                    <button type="button" className="lv-eye"
                      onClick={() => this.setState({ showPassword: !showPassword })}>
                      {showPassword ? '🙈' : '👁'}
                    </button>
                  </div>
                  <div className="lv-hint">Mín. 8 caracteres, una mayúscula, un número y un símbolo.</div>
                </div>
                <div className="lv-field">
                  <label className="lv-label">Confirmar contraseña</label>
                  <div className="lv-input-wrap">
                    <input className="lv-input" type={showConfirm ? 'text' : 'password'} value={confirmPassword}
                      autoComplete="new-password" placeholder="••••••••"
                      onChange={e => this.setState({ confirmPassword: e.target.value })}
                      style={{ paddingRight: 40 }} />
                    <button type="button" className="lv-eye"
                      onClick={() => this.setState({ showConfirm: !showConfirm })}>
                      {showConfirm ? '🙈' : '👁'}
                    </button>
                  </div>
                </div>
                {error && <div className="lv-err">{error}</div>}
                <button className="lv-btn" type="submit" disabled={loading}>
                  {loading ? 'Guardando...' : 'Guardar contraseña'}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  updateClient: bindActionCreators(updateClient, dispatch),
})

export default connect(() => ({}), mapDispatchToProps)(PasswordAssignClientView);
